/* eslint-disable no-alert */
const info = (message: string): void => {
   alert(message);
};

const warn = (message: string): void => {
   alert(message);
};

export default {
   info,
   warn
};